import React from 'react';
import { Carousel } from 'antd';
const OffersCarousel = ({ imgList = [] }) => {
    return (
        <Carousel autoplay autoplaySpeed={10000}>
            {imgList.map((img) => (
                <img
                    key={Math.random()}
                    src={img}
                    alt={'name'}
                    className='w-full object-contain rounded-lg'
                />
            ))}
        </Carousel>
    );
};

export default OffersCarousel;
